module.exports = "/assets/aff28603a6453d8657ae0db69fa8fec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/G3.png
// module id = 1391
// module chunks = 0